export const colors = {
    light_green: "#D4F1E3",
    bold_green: "#1A6A46",
    light_blue: "#DEEEFC",
    bold_blue: "#1C83E2",
    bold_green_secondary: "#02A067",
    light_green_secondary: "#D0FEF6",
    bold_orange: "#BA8806",
    light_orange: "#FFFCF0",
    light_blue_secondary: "#E6ECFF",
    bold_blue_secondary: "#16244B",
    light_grey: "#DDE3EC",
    bold_grey: "#3E4B6F",
    light_blue_tertiary: "#F3F3FF",
    bold_blue_tertiary: "#0C47A5",
    bold_red: '#D32F2F',
    light_red:"#ff4d4f",
}